var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BenchmarkingParams_1;
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { SolutionType } from '../solutionType';
import { SolutionParams } from './solutionParams';
export var BenchmarkingParamNames;
(function (BenchmarkingParamNames) {
    BenchmarkingParamNames["CompanyName"] = "companyName";
    BenchmarkingParamNames["JobTitle"] = "jobTitle";
    BenchmarkingParamNames["Country"] = "country";
    BenchmarkingParamNames["State"] = "state";
    BenchmarkingParamNames["Industry"] = "industry";
    BenchmarkingParamNames["SubIndustry"] = "subIndustry";
    BenchmarkingParamNames["GrowthGoal"] = "growthGoal";
    BenchmarkingParamNames["DataSourceID"] = "dataSourceID";
    BenchmarkingParamNames["SellerColumn"] = "sellerColumn";
    BenchmarkingParamNames["CostColumn"] = "costColumn";
    BenchmarkingParamNames["AttainmentColumn"] = "attainmentColumn";
    BenchmarkingParamNames["RevenueColumn"] = "revenueColumn";
    BenchmarkingParamNames["DateColumn"] = "dateColumn";
    BenchmarkingParamNames["DateStartValue"] = "dateStartValue";
    BenchmarkingParamNames["GeographyColumn"] = "geographyColumn";
    BenchmarkingParamNames["BusinessUnitColumn"] = "businessUnitColumn";
    BenchmarkingParamNames["CostValue"] = "costValue";
    BenchmarkingParamNames["AttainmentValue"] = "attainmentValue";
    BenchmarkingParamNames["RevenueValue"] = "revenueValue";
    BenchmarkingParamNames["RevenuePrevValue"] = "revenuePrevValue";
    BenchmarkingParamNames["MarketingAccepted"] = "marketingAccepted";
})(BenchmarkingParamNames || (BenchmarkingParamNames = {}));
const schema = {
    $id: 'urn:wisepipe-solution-domain:BenchmarkingParams',
    type: 'object',
    properties: {
        companyName: { type: 'string', minLength: 1, maxLength: 100 },
        jobTitle: { type: 'string', minLength: 1, maxLength: 100 },
        country: { type: 'string', maxLength: 100 },
        state: { type: 'string', maxLength: 100 },
        industry: { type: 'string', minLength: 1 },
        subIndustry: { type: 'string', minLength: 1 },
        growthGoal: { type: 'number', minimum: -10, maximum: 10 },
        sellerColumn: { type: 'string' },
        costColumn: { type: 'string' },
        attainmentColumn: { type: 'string' },
        revenueColumn: { type: 'string' },
        dateColumn: { type: 'string' },
        dateStartValue: { type: 'string' },
        geographyColumn: { type: 'string' },
        businessUnitColumn: { type: 'string' },
        costValue: { type: 'number', minimum: 0 },
        attainmentValue: { type: 'number', minimum: 0, maximum: 1 },
        revenueValue: { type: 'number', minimum: 0 },
        revenuePrevValue: { type: 'number', minimum: 0 },
        marketingAccepted: { type: 'boolean' },
        email: { type: 'string', maxLength: 100 },
        lastUpdated: { type: 'number' }
    },
    required: []
};
let BenchmarkingParams = BenchmarkingParams_1 = class BenchmarkingParams extends SolutionParams {
    constructor(companyName, jobTitle, country, state, industry, subIndustry, growthGoal, sellerColumn, costColumn, attainmentColumn, revenueColumn, dateColumn, dateStartValue, geographyColumn, businessUnitColumn, costValue, attainmentValue, revenueValue, revenuePrevValue, marketingAccepted) {
        super(SolutionType.Benchmarking);
        this.companyName = companyName;
        this.jobTitle = jobTitle;
        this.country = country;
        this.state = state;
        this.industry = industry;
        this.subIndustry = subIndustry;
        this.growthGoal = growthGoal;
        this.sellerColumn = sellerColumn;
        this.costColumn = costColumn;
        this.attainmentColumn = attainmentColumn;
        this.revenueColumn = revenueColumn;
        this.dateColumn = dateColumn;
        this.dateStartValue = dateStartValue;
        this.geographyColumn = geographyColumn;
        this.businessUnitColumn = businessUnitColumn;
        this.costValue = costValue;
        this.attainmentValue = attainmentValue;
        this.revenueValue = revenueValue;
        this.revenuePrevValue = revenuePrevValue;
        this.marketingAccepted = marketingAccepted;
        JSON.validate(this, BenchmarkingParams_1);
    }
    toTemplateParams(dataSource) {
        const params = new Map();
        if (!this.companyName)
            throw new Error(`A value for Company Name must be provided`);
        if (!this.jobTitle)
            throw new Error(`A value for Job Title must be provided`);
        params.set(BenchmarkingParamNames.CompanyName, this.companyName);
        params.set(BenchmarkingParamNames.JobTitle, this.jobTitle);
        if (this.country !== undefined)
            params.set(BenchmarkingParamNames.Country, this.country);
        if (this.state !== undefined)
            params.set(BenchmarkingParamNames.State, this.state);
        if (!this.industry)
            throw new Error(`A value for Industry must be provided`);
        if (!this.subIndustry)
            throw new Error(`A value for Sub Industry must be provided`);
        params.set(BenchmarkingParamNames.Industry, this.industry);
        params.set(BenchmarkingParamNames.SubIndustry, this.subIndustry);
        if (this.growthGoal)
            params.set(BenchmarkingParamNames.GrowthGoal, this.growthGoal);
        // If any column is provided, assume they've provided the data source
        const isColumnProvided = this.sellerColumn || this.costColumn || this.attainmentColumn || this.revenueColumn || this.dateColumn;
        if (isColumnProvided) {
            if (!this.sellerColumn)
                throw new Error('A column for Seller must be provided');
            if (!this.costColumn)
                throw new Error('A column for Sales Compensation Cost must be provided');
            if (!this.attainmentColumn)
                throw new Error('A column for Attainment must be provided');
            if (!this.revenueColumn)
                throw new Error('A column for Revenue must be provided');
            if (!this.dateColumn)
                throw new Error('A column for Date must be provided');
            if (!dataSource.columns)
                throw new Error(`Zero columns found for data source ${dataSource.dataSourceID}`);
            const columnNames = dataSource.columns.map((c) => c.name);
            if (!columnNames.includes(this.sellerColumn))
                throw new Error(`Seller column ${this.sellerColumn} not in data source ${dataSource.dataSourceID}`);
            if (!columnNames.includes(this.costColumn))
                throw new Error(`Cost column ${this.costColumn} not in data source ${dataSource.dataSourceID}`);
            if (!columnNames.includes(this.attainmentColumn))
                throw new Error(`Attainment column ${this.attainmentColumn} not in data source ${dataSource.dataSourceID}`);
            if (!columnNames.includes(this.revenueColumn))
                throw new Error(`Revenue column ${this.revenueColumn} not in data source ${dataSource.dataSourceID}`);
            if (!columnNames.includes(this.dateColumn))
                throw new Error(`Date column ${this.dateColumn} not in data source ${dataSource.dataSourceID}`);
            if (this.geographyColumn && !columnNames.includes(this.geographyColumn))
                throw new Error(`Geography column ${this.geographyColumn} not in data source ${dataSource.dataSourceID}`);
            if (this.businessUnitColumn && !columnNames.includes(this.businessUnitColumn))
                throw new Error(`Business Unit column ${this.businessUnitColumn} not in data source ${dataSource.dataSourceID}`);
            if (!this.dateStartValue)
                throw new Error(`A value for Fiscal Year Start must be provided`);
            params.set(BenchmarkingParamNames.DataSourceID, dataSource.dataSourceID);
            params.set(BenchmarkingParamNames.SellerColumn, this.sellerColumn);
            params.set(BenchmarkingParamNames.CostColumn, this.costColumn);
            params.set(BenchmarkingParamNames.AttainmentColumn, this.attainmentColumn);
            params.set(BenchmarkingParamNames.RevenueColumn, this.revenueColumn);
            params.set(BenchmarkingParamNames.DateColumn, this.dateColumn);
            params.set(BenchmarkingParamNames.DateStartValue, this.dateStartValue);
            if (this.geographyColumn)
                params.set(BenchmarkingParamNames.GeographyColumn, this.geographyColumn);
            if (this.businessUnitColumn)
                params.set(BenchmarkingParamNames.BusinessUnitColumn, this.businessUnitColumn);
        }
        else {
            if (!this.costValue)
                throw new Error(`A value for Sales Compensation Cost must be provided`);
            if (!this.attainmentValue)
                throw new Error(`A value for Quota Attainment Percentage must be provided`);
            if (!this.revenueValue)
                throw new Error(`A value for Total Revenue Current Year must be provided`);
            if (!this.revenuePrevValue)
                throw new Error(`A value for Total Revenue Previous Year must be provided`);
            params.set(BenchmarkingParamNames.DataSourceID, dataSource.dataSourceID);
            params.set(BenchmarkingParamNames.CostValue, this.costValue);
            params.set(BenchmarkingParamNames.AttainmentValue, this.attainmentValue);
            params.set(BenchmarkingParamNames.RevenueValue, this.revenueValue);
            params.set(BenchmarkingParamNames.RevenuePrevValue, this.revenuePrevValue);
        }
        if (this.marketingAccepted !== undefined)
            params.set(BenchmarkingParamNames.MarketingAccepted, this.marketingAccepted);
        return params;
    }
    get allParams() {
        return BenchmarkingParams_1.ALL_PARAMS;
    }
    get size() {
        return BenchmarkingParams_1.size();
    }
    static size() {
        return BenchmarkingParams_1.ALL_PARAMS.length;
    }
};
BenchmarkingParams.ALL_PARAMS = [
    BenchmarkingParamNames.CompanyName,
    BenchmarkingParamNames.JobTitle,
    BenchmarkingParamNames.Country,
    BenchmarkingParamNames.State,
    BenchmarkingParamNames.Industry,
    BenchmarkingParamNames.SubIndustry,
    BenchmarkingParamNames.GrowthGoal,
    BenchmarkingParamNames.DataSourceID,
    BenchmarkingParamNames.SellerColumn,
    BenchmarkingParamNames.CostColumn,
    BenchmarkingParamNames.AttainmentColumn,
    BenchmarkingParamNames.RevenueColumn,
    BenchmarkingParamNames.DateColumn,
    BenchmarkingParamNames.DateStartValue,
    BenchmarkingParamNames.GeographyColumn,
    BenchmarkingParamNames.BusinessUnitColumn,
    BenchmarkingParamNames.CostValue,
    BenchmarkingParamNames.AttainmentValue,
    BenchmarkingParamNames.RevenueValue,
    BenchmarkingParamNames.RevenuePrevValue,
    BenchmarkingParamNames.MarketingAccepted
];
BenchmarkingParams = BenchmarkingParams_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(SolutionType.Benchmarking)
], BenchmarkingParams);
export { BenchmarkingParams };
//# sourceMappingURL=benchmarkingParams.js.map